import React from 'react'
import { useTranslation } from 'react-i18next'
import LocalizedLink from '../LocalizedLink/LocalizedLink'

const PageTitle = (props) => {
    const { t } = useTranslation('navbar')
    return (
        <div className="wpo-breadcumb-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-breadcumb-wrap">
                            <h1>{props.pageTitle}</h1>
                            <ul className="wpo-breadcumb-wrap">
                                <li><LocalizedLink to="/home">{t('home')}</LocalizedLink></li>
                                <li><span>{props.pagesub}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageTitle;